// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file types/v1/deal.proto (package types.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file types/v1/deal.proto.
 */
export const file_types_v1_deal: GenFile = /*@__PURE__*/
  fileDesc("ChN0eXBlcy92MS9kZWFsLnByb3RvEgh0eXBlcy52MSpdCgxEZWFsUG9zaXRpb24SHQoZREVBTF9QT1NJVElPTl9VTlNQRUNJRklFRBAAEhUKEURFQUxfUE9TSVRJT05fQklEEAESFwoTREVBTF9QT1NJVElPTl9PRkZFUhACKmcKClNwcmVhZFR5cGUSGwoXU1BSRUFEX1RZUEVfVU5TUEVDSUZJRUQQABIbChdTUFJFQURfVFlQRV9TUFJFQURfQkFTRRABEh8KG1NQUkVBRF9UWVBFX1NQUkVBRF9FWENIQU5HRRACKuMCChFQcm9kdWN0U3ByZWFkVHlwZRIjCh9QUk9EVUNUX1NQUkVBRF9UWVBFX1VOU1BFQ0lGSUVEEAASHAoYUFJPRFVDVF9TUFJFQURfVFlQRV9BUkVBEAESJwojUFJPRFVDVF9TUFJFQURfVFlQRV9ERUxJVkVSWV9QRVJJT0QQAhIhCh1QUk9EVUNUX1NQUkVBRF9UWVBFX0hPVVJfVFlQRRADEiwKKFBST0RVQ1RfU1BSRUFEX1RZUEVfQVJFQV9ERUxJVkVSWV9QRVJJT0QQBBImCiJQUk9EVUNUX1NQUkVBRF9UWVBFX0FSRUFfSE9VUl9UWVBFEAUSMQotUFJPRFVDVF9TUFJFQURfVFlQRV9ERUxJVkVSWV9QRVJJT0RfSE9VUl9UWVBFEAYSNgoyUFJPRFVDVF9TUFJFQURfVFlQRV9BUkVBX0RFTElWRVJZX1BFUklPRF9IT1VSX1RZUEUQByqyAQoURGVhbFN1Ym1pc3Npb25Tb3VyY2USJgoiREVBTF9TVUJNSVNTSU9OX1NPVVJDRV9VTlNQRUNJRklFRBAAEiMKH0RFQUxfU1VCTUlTU0lPTl9TT1VSQ0VfRU5FQ0hBSU4QARInCiNERUFMX1NVQk1JU1NJT05fU09VUkNFX09USEVSX0JST0tFUhACEiQKIERFQUxfU1VCTUlTU0lPTl9TT1VSQ0VfQklMQVRFUkFMEAMqjAEKDERlbGl2ZXJ5VHlwZRIdChlERUxJVkVSWV9UWVBFX1VOU1BFQ0lGSUVEEAASFAoQREVMSVZFUllfVFlQRV9CRxABEhYKEkRFTElWRVJZX1RZUEVfSkVQWBACEhUKEURFTElWRVJZX1RZUEVfRUVYEAMiBAgEEAQqEkRFTElWRVJZX1RZUEVfU1dBUCqTAQoQRGVsaXZlcnlIb3VyVHlwZRIiCh5ERUxJVkVSWV9IT1VSX1RZUEVfVU5TUEVDSUZJRUQQABIbChdERUxJVkVSWV9IT1VSX1RZUEVfQkFTRRABEhsKF0RFTElWRVJZX0hPVVJfVFlQRV9QRUFLEAIiBAgDEAMqG0RFTElWRVJZX0hPVVJfVFlQRV9PRkZfUEVBSyr4AgoSRGVsaXZlcnlQZXJpb2RUeXBlEiQKIERFTElWRVJZX1BFUklPRF9UWVBFX1VOU1BFQ0lGSUVEEAASHgoaREVMSVZFUllfUEVSSU9EX1RZUEVfTU9OVEgQBBIkCiBERUxJVkVSWV9QRVJJT0RfVFlQRV9NVUxUSV9NT05USBAFEiAKHERFTElWRVJZX1BFUklPRF9UWVBFX1FVQVJURVIQBhIfChtERUxJVkVSWV9QRVJJT0RfVFlQRV9TRUFTT04QBxIkCiBERUxJVkVSWV9QRVJJT0RfVFlQRV9GSVNDQUxfWUVBUhAJIgQIARABIgQIAhACIgQIAxADIgQICBAIKhhERUxJVkVSWV9QRVJJT0RfVFlQRV9EQVkqGURFTElWRVJZX1BFUklPRF9UWVBFX1dFRUsqHERFTElWRVJZX1BFUklPRF9UWVBFX1dFRUtFTkQqIkRFTElWRVJZX1BFUklPRF9UWVBFX0NBTEVOREFSX1lFQVJCngEKDGNvbS50eXBlcy52MUIJRGVhbFByb3RvUAFaQmdpdGh1Yi5jb20vZW5lY2hhaW4vZXBvc2l0aW9uLWFwcC9iYWNrZW5kL2dlbi9wcm90by90eXBlcy92MTt0eXBlc6ICA1RYWKoCCFR5cGVzLlYxygIIVHlwZXNcVjHiAhRUeXBlc1xWMVxHUEJNZXRhZGF0YeoCCVR5cGVzOjpWMWIGcHJvdG8z");

/**
 * @generated from enum types.v1.DealPosition
 */
export enum DealPosition {
  /**
   * @generated from enum value: DEAL_POSITION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 買
   *
   * @generated from enum value: DEAL_POSITION_BID = 1;
   */
  BID = 1,

  /**
   * 売
   *
   * @generated from enum value: DEAL_POSITION_OFFER = 2;
   */
  OFFER = 2,
}

/**
 * Describes the enum types.v1.DealPosition.
 */
export const DealPositionSchema: GenEnum<DealPosition> = /*@__PURE__*/
  enumDesc(file_types_v1_deal, 0);

/**
 * @generated from enum types.v1.SpreadType
 */
export enum SpreadType {
  /**
   * @generated from enum value: SPREAD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * スプレッド基準側
   *
   * @generated from enum value: SPREAD_TYPE_SPREAD_BASE = 1;
   */
  SPREAD_BASE = 1,

  /**
   * スプレッド交換側
   *
   * @generated from enum value: SPREAD_TYPE_SPREAD_EXCHANGE = 2;
   */
  SPREAD_EXCHANGE = 2,
}

/**
 * Describes the enum types.v1.SpreadType.
 */
export const SpreadTypeSchema: GenEnum<SpreadType> = /*@__PURE__*/
  enumDesc(file_types_v1_deal, 1);

/**
 * @generated from enum types.v1.ProductSpreadType
 */
export enum ProductSpreadType {
  /**
   * @generated from enum value: PRODUCT_SPREAD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRODUCT_SPREAD_TYPE_AREA = 1;
   */
  AREA = 1,

  /**
   * @generated from enum value: PRODUCT_SPREAD_TYPE_DELIVERY_PERIOD = 2;
   */
  DELIVERY_PERIOD = 2,

  /**
   * @generated from enum value: PRODUCT_SPREAD_TYPE_HOUR_TYPE = 3;
   */
  HOUR_TYPE = 3,

  /**
   * @generated from enum value: PRODUCT_SPREAD_TYPE_AREA_DELIVERY_PERIOD = 4;
   */
  AREA_DELIVERY_PERIOD = 4,

  /**
   * @generated from enum value: PRODUCT_SPREAD_TYPE_AREA_HOUR_TYPE = 5;
   */
  AREA_HOUR_TYPE = 5,

  /**
   * @generated from enum value: PRODUCT_SPREAD_TYPE_DELIVERY_PERIOD_HOUR_TYPE = 6;
   */
  DELIVERY_PERIOD_HOUR_TYPE = 6,

  /**
   * @generated from enum value: PRODUCT_SPREAD_TYPE_AREA_DELIVERY_PERIOD_HOUR_TYPE = 7;
   */
  AREA_DELIVERY_PERIOD_HOUR_TYPE = 7,
}

/**
 * Describes the enum types.v1.ProductSpreadType.
 */
export const ProductSpreadTypeSchema: GenEnum<ProductSpreadType> = /*@__PURE__*/
  enumDesc(file_types_v1_deal, 2);

/**
 * @generated from enum types.v1.DealSubmissionSource
 */
export enum DealSubmissionSource {
  /**
   * @generated from enum value: DEAL_SUBMISSION_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * enechain経由
   *
   * @generated from enum value: DEAL_SUBMISSION_SOURCE_ENECHAIN = 1;
   */
  ENECHAIN = 1,

  /**
   * 他broker経由
   *
   * @generated from enum value: DEAL_SUBMISSION_SOURCE_OTHER_BROKER = 2;
   */
  OTHER_BROKER = 2,

  /**
   * 相対取引
   *
   * @generated from enum value: DEAL_SUBMISSION_SOURCE_BILATERAL = 3;
   */
  BILATERAL = 3,
}

/**
 * Describes the enum types.v1.DealSubmissionSource.
 */
export const DealSubmissionSourceSchema: GenEnum<DealSubmissionSource> = /*@__PURE__*/
  enumDesc(file_types_v1_deal, 3);

/**
 * @generated from enum types.v1.DeliveryType
 */
export enum DeliveryType {
  /**
   * @generated from enum value: DELIVERY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DELIVERY_TYPE_BG = 1;
   */
  BG = 1,

  /**
   * @generated from enum value: DELIVERY_TYPE_JEPX = 2;
   */
  JEPX = 2,

  /**
   * @generated from enum value: DELIVERY_TYPE_EEX = 3;
   */
  EEX = 3,
}

/**
 * Describes the enum types.v1.DeliveryType.
 */
export const DeliveryTypeSchema: GenEnum<DeliveryType> = /*@__PURE__*/
  enumDesc(file_types_v1_deal, 4);

/**
 * @generated from enum types.v1.DeliveryHourType
 */
export enum DeliveryHourType {
  /**
   * @generated from enum value: DELIVERY_HOUR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DELIVERY_HOUR_TYPE_BASE = 1;
   */
  BASE = 1,

  /**
   * akka. MIDDLE
   *
   * @generated from enum value: DELIVERY_HOUR_TYPE_PEAK = 2;
   */
  PEAK = 2,
}

/**
 * Describes the enum types.v1.DeliveryHourType.
 */
export const DeliveryHourTypeSchema: GenEnum<DeliveryHourType> = /*@__PURE__*/
  enumDesc(file_types_v1_deal, 5);

/**
 * @generated from enum types.v1.DeliveryPeriodType
 */
export enum DeliveryPeriodType {
  /**
   * @generated from enum value: DELIVERY_PERIOD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DELIVERY_PERIOD_TYPE_MONTH = 4;
   */
  MONTH = 4,

  /**
   * @generated from enum value: DELIVERY_PERIOD_TYPE_MULTI_MONTH = 5;
   */
  MULTI_MONTH = 5,

  /**
   * @generated from enum value: DELIVERY_PERIOD_TYPE_QUARTER = 6;
   */
  QUARTER = 6,

  /**
   * @generated from enum value: DELIVERY_PERIOD_TYPE_SEASON = 7;
   */
  SEASON = 7,

  /**
   * FY 1年物
   *
   * @generated from enum value: DELIVERY_PERIOD_TYPE_FISCAL_YEAR = 9;
   */
  FISCAL_YEAR = 9,
}

/**
 * Describes the enum types.v1.DeliveryPeriodType.
 */
export const DeliveryPeriodTypeSchema: GenEnum<DeliveryPeriodType> = /*@__PURE__*/
  enumDesc(file_types_v1_deal, 6);

